import { IconButton, Tooltip } from "@material-ui/core"
import { Delete } from "@material-ui/icons"
import LinkIcon from "@material-ui/icons/Link"
import { Image, Transformation } from "cloudinary-react"
import PropTypes from "prop-types"
import { useCallback, useContext, useState } from "react"
import { uploadThumbnail } from "~/actions/upload"
import EditIcon from "~/assets/Icons/edit-icon.svg"
import AppContext from "~/contexts/App"

import Box from "~/components/Common/Box"
import FileUpload from "../FileUpload"
import PermissionsWrapper from "../PermissionsWrapper"
import useStyles from "./styles"

const ThumbnailUpload = ({
  title,
  cloudinaryUploadPreset,
  onUpload,
  value,
  type,
  noCrop = true,
  // defaultUpload = false,
}) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const { openDialog, openSnackBar } = useContext(AppContext)
  const [style, setStyle] = useState({ display: "none" })

  // useEffect(() => {
  //   if (defaultUpload !== false) {
  //     handleDefaultUpload()
  //   }
  // }, [defaultUpload])

  // const handleDefaultUpload = () => {
  //   setLoading(true)
  //   uploadThumbnail(defaultUpload, cloudinaryUploadPreset) // Replace DEFAULT_IMAGE_FILE with your default image file
  //     .then((uploadRes) => onUpload(uploadRes, setLoading, type))
  //     .catch((err) => {
  //       setLoading(false)
  //       console.error(err)
  //     })
  // }

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles[0].type === "image/gif") {
        if (type === "background_image") {
          openSnackBar({ message: "background image cannot be a gif" })
        } else {
          setLoading(true)
          uploadThumbnail(acceptedFiles[0], cloudinaryUploadPreset)
            .then((uploadRes) => onUpload(uploadRes, setLoading, type))
            .catch((err) => {
              setLoading(false)
              console.error(err)
            })
        }
      } else if (type === "question" || noCrop) {
        setLoading(true)
        uploadThumbnail(acceptedFiles[0], cloudinaryUploadPreset)
          .then((uploadRes) => onUpload(uploadRes, setLoading, type))
          .catch((err) => {
            setLoading(false)
            console.error(err)
          })
      } else {
        openDialog("cropThumbnail", {
          acceptedFiles,
          setLoading,
          type,
        })
          .then((res) => uploadThumbnail(res, cloudinaryUploadPreset))
          .then((uploadRes) =>
            onUpload(
              {
                data: {
                  ...uploadRes.data,
                  original_filename: acceptedFiles[0].name,
                },
              },
              setLoading,
              type,
            ),
          )
          .catch((err) => {
            setLoading(false)
            console.error(err)
          })
      }
    },
    [cloudinaryUploadPreset, onUpload],
  )
  const renderDeleteImage = () => {
    return (
      <Tooltip title="Delete Image" placement="top">
        <IconButton
          className={classes.delete}
          color="inherit"
          style={{ zIndex: "10" }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            openDialog("deleteImageDialog", { onUpload, setLoading, type })
          }}
        >
          <Delete style={{ color: "red" }} />
        </IconButton>
      </Tooltip>
    )
  }

  const renderCopyImage = () => {
    return (
      <Tooltip title="Copy Image" placement="top">
        <IconButton
          className={classes.copyImage}
          color="inherit"
          style={{ zIndex: "10" }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            navigator.clipboard.writeText(value?.url)
            openSnackBar({ message: "Image URL copied to clipboard" })
          }}
        >
          <LinkIcon style={{ color: "white" }} />
        </IconButton>
      </Tooltip>
    )
  }

  if (type !== "badge_image") {
    return (
      <FileUpload
        title={title ? title : "Drop thumbnail here"}
        onDrop={onDrop}
        showLoading={loading}
      >
        {value?.public_id && (
          <Box className={classes.thumbnailBox}>
            <PermissionsWrapper permissionGroup="admin">
              {renderDeleteImage()}
            </PermissionsWrapper>
            {renderCopyImage()}
            <PermissionsWrapper permissionGroup="admin">
              <Box className={classes.editBox}>
                <img
                  src={EditIcon}
                  alt="Edit thumbnail"
                  style={{ width: 24 }}
                />
              </Box>
            </PermissionsWrapper>
            <Image
              publicId={value.public_id}
              style={{ verticalAlign: "bottom", width: "100%" }}
            >
              {type != "question" && !noCrop && (
                <Transformation crop="fill" gravity="auto" aspectRatio="16:9" />
              )}
            </Image>
          </Box>
        )}
      </FileUpload>
    )
  } else {
    return (
      <FileUpload
        title={title ? title : "Drop thumbnail here"}
        onDrop={onDrop}
        showLoading={loading}
        childHeight={150}
        childWidth={150}
      >
        {value?.public_id && (
          <Box className={classes.badgeBox}>
            <PermissionsWrapper permissionGroup="admin">
              {renderDeleteImage()}
            </PermissionsWrapper>
            {renderCopyImage()}
            <PermissionsWrapper permissionGroup="admin">
              <Box className={classes.editBadgeBox}>
                <img
                  src={EditIcon}
                  alt="Edit thumbnail"
                  style={{ width: 24 }}
                />
              </Box>
            </PermissionsWrapper>
            <Image
              publicId={value.public_id}
              style={{ width: "100%", height: "100%", borderRadius: "100%" }}
            ></Image>
          </Box>
        )}
      </FileUpload>
    )
  }
}

ThumbnailUpload.propTypes = {
  title: PropTypes.string,
  cloudinaryUploadPreset: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  onUpload: PropTypes.func,
  noCrop: PropTypes.bool,
}

export default ThumbnailUpload
